import PocketBase from 'pocketbase';

// --- RETOUR AU PROXY OPTIMISÉ (Après réparation de setupProxy.js) ---
const isDev = process.env.NODE_ENV === 'development';
export const PB_URL = isDev
  ? window.location.origin // On utilise votre adresse locale (3001) car le CORS y est autorisé par le proxy
  : (process.env.REACT_APP_PB_URL || 'https://aef32.infocolab.online');

export const pb = new PocketBase(PB_URL);

// On désactive l'auto-annulation pour la stabilité
pb.autoCancellation(false);

export function getFileUrl(record, fileName) {
  if (!record || !fileName) return '';
  // Toujours appeler le serveur de prod pour les images (plus rapide)
  return `https://aef32.infocolab.online/api/files/${record.collectionId || record.collectionName}/${record.id}/${fileName}`;
}
